import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'pipeLimiteCaractere'
})
export class PipeLimiteCaractere implements PipeTransform {
    transform(value: string): string {
        if(value == null || value == undefined){
            return ''
        }
        if(value && value.length > 10){
            return value.substr(0, 10) + '...';
        }else{
            return value;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/restricted/pipe/pipeLimiteCaractere.ts